import { z } from 'zod';

import {
    createDeleteSchema,
    createUpdateSchemaFromAdd,
    requiredNumber,
    requiredUuid,
} from './fields';
import { SYNC_UPDATE_VALIDATION_SCHEMA } from './common';

export const createEventUsersAddSchema = () =>
    z.object({
        id: requiredUuid(),
        created_at: requiredNumber(),
        updated_at: requiredNumber(),
        event_id: requiredUuid(),
        user_id: requiredUuid(),
        organisation_id: requiredUuid(),
        client_created_at: requiredNumber(),
        client_updated_at: requiredNumber(),
        archived_at: requiredNumber(),
    });

export const createEventUsersUpdateSchema = () =>
    createUpdateSchemaFromAdd(
        createEventUsersAddSchema(),
        SYNC_UPDATE_VALIDATION_SCHEMA.event_users,
    );

export const createEventUsersDeleteSchema = () => createDeleteSchema();

export const createEventUsersSchemas = () => ({
    add: createEventUsersAddSchema(),
    update: createEventUsersUpdateSchema(),
    delete: createEventUsersDeleteSchema(),
});
